const { forEach } = require('lodash'), { createInspirationTiles } = require('./inspiration-tile-factory');

function mergeInspirationTiles(cards, inspirationTiles, { pageNumber, pageSize = Number.MAX_VALUE, type }) {
    const pageOffset = pageNumber != null ? pageSize * (pageNumber - 1) : 0;

    // Merge inspiration cards with actual cards
    forEach(inspirationTiles, (inspTiles, position) => {
        position = parseInt(position, 10) - pageOffset;

        if (position < 0 || position >= pageSize) return;

        Array.prototype.splice.apply(cards, [position, 0]
            .concat(createInspirationTiles(inspTiles, type)));
    });

    return cards;
}

module.exports = { mergeInspirationTiles };



// WEBPACK FOOTER //
// ./src/shop/tiles/merge-inspiration-tiles.js